
export default [
  {
    path: 'invite',
    component: resolve => { require(['../views/backend/invite'], resolve); },
  },
  {
    path: 'member',
    component: resolve => { require(['../views/backend/member'], resolve); },
  },
  {
    path: 'totalQuantity',
    component: resolve => { require(['../views/backend/TokensStatistics/total-quantity'], resolve); },
  },
  {
    path: 'totalModel',
    component: resolve => { require(['../views/backend/TokensStatistics/total-model'], resolve); },
  },
  {
    path: 'totalAccount',
    component: resolve => { require(['../views/backend/TokensStatistics/total-account'], resolve); },
  },
  {
    path: 'totalDay',
    component: resolve => { require(['../views/backend/TokensStatistics/total-day'], resolve); },
  },
  {
    path: 'totalMonth',
    component: resolve => { require(['../views/backend/TokensStatistics/total-month'], resolve); },
  }
  
]